export enum FIELD {
  NAME = 'name',
  COMPANY = 'company',
  PHONE = 'phoneNumber',
  CONTENT = 'content',
  EMAILS = 'emails',
  INQUIRY_RECEIVER_EMAILS = 'inquiryReceiverEmails'
}

export const EDITOR_CHARACTER_LIMITED = 3000;
